import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-default-footer":"","disable-pagination":"","items-per-page":-1,"fixed-header":"","dense":"","height":_vm.height},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var headers = ref.headers;
return [_c('tr',_vm._l((headers),function(col){return _c('td',{key:col.value,class:col.align === 'center' ? 'text-center' : ''},[_vm._t('item.' + col.value,function(){return [_vm._v(" "+_vm._s(_vm.format(_vm.getValue(item, col.value)))+" ")]},{"item":item})],2)}),0)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }